import { useThreadPreviewReadOnly } from '@/features/chat/threadPreviewReadOnly'
import { getUserChatBubbleLayoutClasses } from './getUserChatBubbleLayoutClasses'
import { useUserChatBubbleCoreState } from './useUserChatBubbleCoreState'
import { useUserChatBubbleHover } from './useUserChatBubbleHover'

export function useUserChatBubbleViewModel(props) {
  const {
    hideActions = false,
    isEditing = false,
    reactions = [],
    bubbleAlign = 'end',
    onReaction,
  } = props
  const readOnly = useThreadPreviewReadOnly()

  const core = useUserChatBubbleCoreState(props)
  const hover = useUserChatBubbleHover(core.moreMenuAnchor, core.reactionPickerAnchorEl)

  const handleReaction = (emoji) => {
    onReaction?.(emoji)
    core.setReactionPickerAnchorEl(null)
  }

  const layout = getUserChatBubbleLayoutClasses(bubbleAlign, reactions.length > 0)
  const showFloatingToolbar =
    hideActions &&
    !readOnly &&
    !isEditing &&
    (hover.hoverInBubbleZone || Boolean(core.moreMenuAnchor) || Boolean(core.reactionPickerAnchorEl))

  return {
    ...core,
    hover,
    handleReaction,
    ...layout,
    showFloatingToolbar,
    useFloatingActions: hideActions && !readOnly && !isEditing,
    showBottomActions: !hideActions && !readOnly,
  }
}
